export default __webpack_public_path__ + "static/media/sedan.cf1138cf.svg";